import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	successMessage: {
		id: 'servicedesk-customer-permissions.form.success-message',
		defaultMessage: 'Customer permissions saved',
		description: 'success title for success toast message',
	},
	failureMessage: {
		id: 'servicedesk-customer-permissions.form.failure-message',
		defaultMessage: 'Something has gone wrong with your request.',
		description: 'flag title for failure toast message',
	},
	failureDescriptionMessage: {
		id: 'servicedesk-customer-permissions.form.failure-description-message',
		defaultMessage: 'If symptoms persist contact your System Administrator.',
		description: 'flag description for failure toast message',
	},
});
